/* eslint-disable  import/no-default-export */

export default [
  'placingTermsApi',
  'store',
  function (placingTermsApi) {
    const isAvailable = () => {
      return placingTermsApi.isMultiPostingAvailable;
    };

    const isShowPopup = offer => isAvailable() && (!offer.multiposting || !offer.multiposting.enabled);

    return {
      isAvailable,
      isShowPopup,
    };
  },
];
